import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";
import "./navbar.css";
import rs_logo from "../../assets/images/roadsense_logo.png";
import "../../styles/style.css"

const NavbarLanding = () => {
  return (
    <nav className="navbar_landing">
      
    <div className="container-navbar">
      <div className="index_logo">
        <Link to="/">
          <img className="navbar-logo-1" src={rs_logo}></img>
        </Link>
      </div>

      <div className="nav-elements">
        <NavLink 
          className="nav-elements-ind"
           to="/about"
        >
          ABOUT
        </NavLink>

        <NavLink 
          className="nav-elements-ind"
          to="/help"        
        >
          HELP
        </NavLink>

        {/* <NavLink 
          className="nav-elements-ind"
          to="/legal"
        >
          LEGAL
        </NavLink> */}

      </div>
    </div>
  </nav>
  );
};

export default NavbarLanding;
